import React from 'react';

const shapes = {
  play: <path d="m9 6 9 6-9 6V6Z" fill="currentColor" stroke="none" />,
  back: <><path d="m15 18-6-6 6-6" /><path d="M9 12h11" /></>,
  link: <><path d="M10 13a5 5 0 0 0 7.5.5l2-2a5 5 0 0 0-7.1-7.1l-1.2 1.2" /><path d="M14 11a5 5 0 0 0-7.5-.5l-2 2a5 5 0 0 0 7.1 7.1l1.2-1.2" /></>,
  film: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M7 5v14M17 5v14M3 9h4m-4 6h4m10-6h4m-4 6h4" /></>,
  chat: <path d="M20 11.5a7.5 7.5 0 0 1-7.5 7.5 8 8 0 0 1-3.2-.6L4 20l1.6-5.3a8 8 0 0 1-.6-3.2 7.5 7.5 0 0 1 15 0Z" />,
  users: <><circle cx="9" cy="8" r="3" /><path d="M3 20v-2a6 6 0 0 1 12 0v2M16 5.3a3 3 0 0 1 0 5.4M17 14a5 5 0 0 1 4 5v1" /></>,
  mic: <><rect x="9" y="3" width="6" height="12" rx="3" /><path d="M5 11a7 7 0 0 0 14 0M12 18v3m-4 0h8" /></>,
  micOff: <><path d="M4 4 20 20M9 9v3a3 3 0 0 0 5.1 2.1M15 9V6a3 3 0 0 0-5.1-2.1M5 11a7 7 0 0 0 11.9 5M19 11a7 7 0 0 1-.7 3M12 18v3m-4 0h8" /></>,
  volume: <><path d="M4 9v6h4l5 4V5L8 9H4Z" /><path d="M17 9a4 4 0 0 1 0 6M19.5 6a8 8 0 0 1 0 12" /></>,
  exit: <><path d="M10 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5M14 7l5 5-5 5M19 12H9" /></>,
  check: <path d="m5 12 4 4L19 6" />,
  bolt: <path d="m13 2-8 11h6l-1 9 9-12h-6l1-8Z" />,
  send: <><path d="M4 12h16M14 6l6 6-6 6" /></>,
};

export default function RoomIcon({ name, size = 18, className = '' }) {
  return (
    <svg className={`ui-icon ${className}`} width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true" focusable="false">
      {shapes[name]}
    </svg>
  );
}
